import {getType} from 'apis/model/base'
import classNames from 'classnames'
import EmptyHolder from 'components/EmptyHolder'
import _ from 'lodash'
import React, {useContext} from 'react'
import CodiDocumentContext from 'views/Document/CodiDocumentContext'
import {Responses} from 'views/Feed/Responses'
import {renderElse, renderOwnChild} from 'views/Shared'
import {CodiSiderHeading} from './CodiSiderHeading'
import {BsChatFill} from "react-icons/bs";

const CodiArticleComments = ({
  item,
  header = null,
  Wrapper = renderOwnChild,
}) => {
  const [id, type] = [item?.id, getType(item)]

  return renderElse(
    _.isEmpty(item),
    <Wrapper>
      {header}
      <Responses {...{ id, type, renderEmpty: () => <EmptyHolder /> }} />
    </Wrapper>
  )
}

const CodiDocumentComments = ({ style, className, Wrapper = 'div' }) => {
  const { item } = useContext(CodiDocumentContext)

  return (
    <Wrapper
      style={style}
      className={classNames('flex flex-col', className)}>
      <CodiSiderHeading
          title="comment"
          icon={<BsChatFill
            size={20}
            style={{ marginTop: '0.15rem' }}
            className="text-primary"
          />
        }
      />

      <div className="timeline-group-header">
        <CodiArticleComments
          item={item}
        />
      </div>
    </Wrapper>
  )
}

export default CodiDocumentComments
